import * as Preact from "preact"
import Objdict from "objdict"
import {nanoid} from "nanoid"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import Stage from "@fae/source/models/Stage.js"
import Step from "@fae/source/models/Step.js"
import Random from "@fae/source/utility/Random.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"

import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"

import items from "@fae/source/data/games/ember/items.jsx"
import envkits from "@fae/source/data/games/ember/envkits.js"
import GenerateEnvironmentArt from "@fae/source/data/games/ember/utility/GenerateEnvironmentArt.js"

import * as DiceboundFlow from "@fae/source/data/games/ember/scripts/DiceboundFlow.js"
import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import RollPhase from "@fae/source/data/games/ember/scripts/RollPhase.js"
import GenerateEncounter from "@fae/source/data/games/ember/scripts/GenerateEncounter.js"
import GenerateOverworldMap from "@fae/source/data/games/ember/scripts/GenerateOverworldMap.js"
import EmberRandomEvents from "@fae/source/data/games/ember/scripts/EmberRandomEvents.js"

import LearnToRightClickModal from "@fae/source/data/games/ember/scripts/modals/LearnToRightClickModal.jsx"
import OverworldModal from "@fae/source/data/games/ember/scripts/modals/OverworldModal.jsx"
// import InterstitialModal from "@fae/source/data/games/ember/scripts/modals/InterstitialModal.jsx"
import FirstTimeRollModal from "@fae/source/data/games/ember/scripts/modals/FirstTimeRollModal.jsx"
import LootPassiveModal from "@fae/source/data/games/ember/scripts/modals/LootPassiveModal.jsx"
import MerchantModal from "@fae/source/data/games/ember/scripts/modals/MerchantModal.jsx"
import LootModal from "@fae/source/data/games/ember/scripts/modals/LootModal.jsx"

import RollingHud from "@fae/source/data/games/ember/views/hud/RollingHud.jsx"
import TutorialHud from "@fae/source/data/games/ember/views/hud/TutorialHud.jsx"
import TriangleHud from "@fae/source/data/games/ember/views/hud/TriangleHud.jsx"

const STARTING_ROLLCOUNT = 3

// TODO: move into utility
function toPathKey(a, b) {
    return a.x + "x" + a.y + "to" + b.x + "x" + b.y
}
// TODO: move into utility
function generatePaths(encounters) {
    const paths = {}
    encounters.forEach((encounter, index) => {
        let previousEncounter = encounters[index]
        let nextEncounter = encounters[index + 1]
        if(previousEncounter == undefined) return
        if(nextEncounter == undefined) return

        paths[toPathKey(previousEncounter.position, nextEncounter.position)] = true
    })
    return paths
}

const OVERWORLD = {
    "images": [
        {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-3-base.lowres.png")},
        {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-DIM.png")},
        // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-LIT.png")},
        // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier3.png")},
        // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier2.png")},
        // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier1.png")},
        // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-0-eyes.png")},
        // // {"url": require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-examplepath.png")},
        {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.lowres.png"), "blendmode": "overlay", "opacity": 0.2},
        {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.lowres.png"), "size": "contain"},
    ],
    "encounters": [
        {"position": {"x": 0, "y": 4}, "type": "first-combat", "encounterKey": "1", "wasSelected": true, "items": [
            {...items["twisted-dagger"]},
            {...items["tower-shield"]},
            {...items["lancer"]},
        ]}, // start // "items": [{...items["tower-shield"]}, {...items["berserker-blade"]}, {...items["killing-edge"]}

        // south pass
        {"position": {"x": 1, "y": 4}, "type": "standard-combat", "encounterKey": "1-1-1", "encounterTemplate": {"unitCount": 5, "unitKeys": ["ember/wisp-red", "ember/wisp-red", "ember/wisp-blue", "ember/wisp-green", "ember/wisp-green"]}, "items": [
            {...items["burning-blade"]},
            {...items["firekeeper-greataxe"]},
            {...items["bone-bow"]},
        ]},
        {"position": {"x": 2, "y": 4}, "type": "campfire", "encounterKey": "camp", "encounterTemplate": {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]}},
        {"position": {"x": 3, "y": 4}, "type": "elite-combat", "encounterKey": "1-1-2", "encounterTemplate": {"bossUnitKey": "ember/boglord-green", "unitKeys": ["ember/boglet-green", "ember/boglet-green", "ember/boglet-green", "ember/boglet-green"]}},
        {"position": {"x": 4, "y": 3}, "type": "merchant", "encounterKey": "1-1-3"}, // , "encounterTemplate": {"bossUnitKey": "ember/mara"}}, // random
        {"position": {"x": 6, "y": 2}, "type": "standard-combat", "encounterKey": "1-2-1", "encounterTemplate": {"unitKeys": ["ember/leshy-green", "ember/leshy-green", "ember/woodsman-green", "ember/woodsman-green"]}},
        {"position": {"x": 7, "y": 2}, "type": "elite-combat", "encounterKey": "1-2-2", "encounterTemplate": {"unitKeys": ["ember/banshee-blue", "ember/banshee-blue", "ember/banshee-blue", "ember/banshee-blue"]}},
        {"position": {"x": 8, "y": 2}, "type": "standard-combat", "encounterKey": "1-2-3", "encounterTemplate": {"unitCount": 4, "unitKeys": ["ember/bones-blue", "ember/bones-blue", "ember/bones-red", "ember/bones-red", "ember/bones-green"]}},
        {"position": {"x": 9, "y": 1}, "type": "campfire", "encounterKey": "camp", "encounterTemplate": {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]}},

        // optional south pass
        {"position": {"x": 3, "y": 3}, "type": "standard-combat", "encounterKey": "2-2-2", "encounterTemplate": {"unitCount": 4, "unitKeys": ["ember/hare-red", "ember/hare-red", "ember/hare-red", "ember/hare-red"]}},

        {"position": {"x": 5, "y": 3}, "type": "standard-combat", "encounterKey": "2-3-3", "encounterTemplate": {"unitCount": 4, "unitKeys": ["ember/crow-red", "ember/crow-red", "ember/crow-green", "ember/crow-green"]}},
        {"position": {"x": 6, "y": 3}, "type": "treasure", "encounterKey": "camp", "encounterTemplate": {"unitCount": 0, "spotKey": "center", "unitKeys": []}},

        {"position": {"x": 7, "y": 1}, "type": "merchant", "encounterKey": "camp", "encounterTemplate": {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]}}, // random
        {"position": {"x": 8, "y": 1}, "type": "elite-combat", "encounterKey": "2-3-1", "encounterTemplate": {"bossUnitKey": "ember/jester-blue", "unitKeys": ["ember/wisp-red", "ember/wisp-green", "ember/wisp-red", "ember/wisp-green"]}},

        // north pass
        {"position": {"x": 1, "y": 3}, "type": "elite-combat", "encounterKey": "2-2-1", "encounterTemplate": {"bossUnitKey": "ember/kikimora-green", "unitKeys": ["ember/crow-red", "ember/crow-blue", "ember/crow-red", "ember/crow-blue"]}, "items": [
            {...items["burning-blade"]},
            {...items["firekeeper-greataxe"]},
            {...items["bone-bow"]},
        ]},
        {"position": {"x": 2, "y": 2}, "type": "treasure", "encounterKey": "camp", "encounterTemplate": {"unitCount": 0, "spotKey": "center", "unitKeys": []}},
        {"position": {"x": 3, "y": 2}, "type": "standard-combat", "encounterKey": "1-3-1", "encounterTemplate": {"unitCount": 4, "unitKeys": ["ember/hare-red", "ember/hare-red", "ember/hare-red", "ember/hare-red"]}},
        // {"position": {"x": 3, "y": 2}, "type": "standard-combat", "encounterKey": "1-3-2", "encounterTemplate": {"unitCount": 4, "unitKeys": ["ember/crow-red", "ember/crow-red", "ember/crow-green", "ember/crow-green"]}},
        {"position": {"x": 4, "y": 2}, "type": "standard-combat", "encounterKey": "1-3-3", "encounterTemplate": {"bossUnitKey": "ember/stag-blue", "unitKeys": ["ember/wolf-green", "ember/wolf-blue", "ember/wolf-green", "ember/wolf-blue"]}},
        {"position": {"x": 5, "y": 2}, "type": "campfire", "encounterKey": "camp", "encounterTemplate": {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]}}, // center
        {"position": {"x": 6, "y": 1}, "type": "standard-combat", "encounterKey": "2-1-1", "encounterTemplate": {"unitKeys": ["ember/mothman-blue", "ember/mothman-blue", "ember/mothman-blue", "ember/mothman-blue"]}},
        {"position": {"x": 7, "y": 0}, "type": "elite-combat", "encounterKey": "2-1-2", "encounterTemplate": {"bossUnitKey": "ember/blazing-red", "unitKeys": ["ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red"]}},
        {"position": {"x": 8, "y": 0}, "type": "campfire", "encounterKey": "camp", "encounterTemplate": {"unitCount": 1, "spotKey": "center", "unitKeys": ["ember/campfire"]}},
        {"position": {"x": 9, "y": 0}, "type": "standard-combat", "encounterKey": "2-1-3", "encounterTemplate": {"unitKeys": ["ember/leshy-green", "ember/leshy-green", "ember/woodsman-green", "ember/woodsman-green"]}},
        {"position": {"x": 10, "y": 0}, "type": "final-combat", "encounterKey": "2-4-3", "encounterTemplate": {"bossUnitKey": "ember/lordandlady-green", "unitKeys": ["ember/knight-green", "ember/knight-green"]}}, // end
        {"position": {"x": 11, "y": 0}, "type": "exit"}, // end

        // optional north paths
        {"position": {"x": 2, "y": 3}, "type": "merchant"},
        {"position": {"x": 4, "y": 1}, "type": "elite-combat", "encounterKey": "2-2-3", "encounterTemplate": {"bossUnitKey": "ember/bear-red", "unitKeys": ["ember/wolf-green", "ember/wolf-blue", "ember/wolf-green", "ember/wolf-blue"]}},
        {"position": {"x": 5, "y": 1}, "type": "merchant", "encounterKey": "camp", "encounterTemplate": {"unitCount": 0, "spotKey": "center", "unitKeys": []}},

        // UNUSED
        // "ember/bull-red"
        // "ember/kelpie-blue", "ember/kelpie-green"
        // {"unitKeys": ["ember/fish-red", "ember/fish-blue", "ember/fish-red", "ember/fish-blue"]}
        // {"bossUnitKey": "ember/blazing-red", "unitKeys": ["ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red", "ember/ashwraith-red"]}
        // {"bossUnitKey": "ember/pirate-red", "unitKeys": ["ember/pirate-blue", "ember/pirate-blue", "ember/pirate-blue", "ember/pirate-blue"]}
        // {"bossUnitKey": "ember/rusalka-blue", "unitKeys": ["ember/kelpie-green", "ember/fish-red", "ember/kelpie-green", "ember/fish-red"]}
        // {"bossUnitKey": "ember/priestess-blue", "unitKeys": ["ember/bones-blue", "ember/bones-red", "ember/bones-red", "ember/bones-green", "ember/bones-green"]}
        //
    ],
    "paths": {
        ...generatePaths([
            {"position": {"x": 0, "y": 4}}, // start
            {"position": {"x": 1, "y": 4}},
            {"position": {"x": 2, "y": 4}},
            {"position": {"x": 3, "y": 4}},
            {"position": {"x": 4, "y": 3}},
            {"position": {"x": 5, "y": 2}}, // center
            {"position": {"x": 6, "y": 2}},
            {"position": {"x": 7, "y": 2}},
            {"position": {"x": 8, "y": 2}},
            {"position": {"x": 9, "y": 1}},
            {"position": {"x": 10, "y": 0}}, // end
        ]),
        ...generatePaths([
            {"position": {"x": 0, "y": 4}}, // start
            {"position": {"x": 1, "y": 3}},
            {"position": {"x": 2, "y": 2}},
            {"position": {"x": 3, "y": 2}},
            {"position": {"x": 4, "y": 2}},
            {"position": {"x": 5, "y": 2}}, // center
            {"position": {"x": 6, "y": 1}},
            {"position": {"x": 7, "y": 0}},
            {"position": {"x": 8, "y": 0}},
            {"position": {"x": 9, "y": 0}},
            {"position": {"x": 10, "y": 0}}, // end
        ]),
        ...generatePaths([
            {"position": {"x": 1, "y": 3}},
            {"position": {"x": 2, "y": 3}},
            {"position": {"x": 3, "y": 2}},
        ]),
        ...generatePaths([
            {"position": {"x": 2, "y": 4}},
            {"position": {"x": 3, "y": 3}},
            {"position": {"x": 4, "y": 3}},
        ]),
        ...generatePaths([
            {"position": {"x": 3, "y": 2}},
            {"position": {"x": 4, "y": 1}},
            {"position": {"x": 5, "y": 1}},
            {"position": {"x": 6, "y": 1}},
        ]),
        ...generatePaths([
            {"position": {"x": 6, "y": 2}},
            {"position": {"x": 7, "y": 1}},
            {"position": {"x": 8, "y": 1}},
            {"position": {"x": 9, "y": 0}},
        ]),
        ...generatePaths([
            {"position": {"x": 4, "y": 3}},
            {"position": {"x": 5, "y": 3}},
            {"position": {"x": 6, "y": 3}},
            {"position": {"x": 7, "y": 2}},
        ]),
        ...generatePaths([
            {"position": {"x": 10, "y": 0}, "type": "final-combat"}, // end
            {"position": {"x": 11, "y": 0}, "type": "exit"}, // end
        ]),
    },
    "player": {
        "position": {"x": 0, "y": 4},
        // "encounter": {"position": {"x": 0, "y": 4}, "type": "first-combat", "wasSelected": true}, // start
    },
    "width": 11,
    "height": 5,
}
OVERWORLD.player.encounter = OVERWORLD.encounters[0]

export default {
    "key": "protoencounters",
    "stage": {
        "configuration": {
            "useEquippedItemOnly": true,
            "isNotDividedByTen": true,
            "useNumberedItemsOnly": true,
        },
        "images": [
            // {
            //     "url": require("../bg.png"),
            //     "position": {"x": 1.5, "y": 5, "z": 1},
            //     "width": 16, "height": 9,
            //     // "screenspace": "camera",
            // },
            // {
            //     "url": require("./map_26x21.png"),
            //     "position": {"x": 0, "y": 0, "z": 2},
            //     "width": 26, "height": 21,
            //     "isSquiggling": true,
            // }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
            "width": 16,
            "height": 9,
        }),
        "hud": function(stage) {
            return [
                RollingHud(stage),
                TutorialHud(stage),
                TriangleHud(stage),
            ]
        },
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),

                    Step.deltastage({
                        "overworld": OVERWORLD,
                    }),
                    PlotSteps.SpawnPlayerParty({
                        "defaultPartyUnitKeys": ["ashe", "gwyn", "kullervo"]
                    }),
                    Step.deltastage({
                        "images": GenerateEnvironmentArt({
                            "encounters": require("./encounters.json"),
                            "kits": envkits["woods"]
                        })
                    }),
                    // ...LootModal(), // HEY!! WHY DOES THIS REQUIRE THE ELLIPSIS TO WORK???
                    // MerchantModal(), // HEY!! WHY DOES THIS REQUIRE THE ELLIPSIS TO WORK???

                    // {"func": () => {
                    //     App.game.chapter.selection.camera.position = {
                    //         "x": -60,
                    //         "y": 4.5,
                    //         "z": 1
                    //     }
                    // }},
                    // Step.deltastage({
                    //     "currentEncounterKey": "a",
                    // }),
                    PlotSteps.PlayAudio("Ambience:Forest"),

                    // PlotSteps.PlayStinger("Stinger:Start"),
                    // PlotSteps.ChapterStart([
                    //     "Act I", "The Darkwood"
                    // ]), // THIS IS ANIMATING WEIRDLY RIGHT NOW
                    // Step.flag("blackout", true),
                    // "CRESCENT: ENTERS #position:4 #direction:left",
                    // "CRESCENT: Hail, traveler!!",
                    // "CRESCENT: Welcome to Embergrim. This is but a demo, a work-in-progress.",

                    // PlotSteps.PlayAudio("Ember:Music:Campfire"),
                    // {"func": () => window.goldCount = 50},
                    // Step.flag("blackout", true),
                    // "CRESCENT: ENTERS #position:4 #direction:left",
                    // "CRESCENT: Hail, Pigsquad!!",
                    // "CRESCENT: Welcome back to Embergrim.",
                    // "CRESCENT: You might remember us from the last Summer Slow Jam, back in June!!",
                    // "CRESCENT: But since then, we've added a bunch of new items, and full inventory management.",
                    // "CRESCENT: There is so much to see, but only so much time on the twitch stream. So let's skip to the new stuff.",
                    // "CRESCENT: Here is 50 silver!! Spend it wisely.",
                    // Step.flag("blackout", false),
                    // MerchantModal(),

                    PlotSteps.PlayAudio("Ember:Music:Encounter:1"),
                    Step.deltastage({
                        "player": {
                            "rollcount": STARTING_ROLLCOUNT,
                            "phase": "playing",
                            "zoomout": 0.8,
                        },
                    }),
                    PlotSteps.Wait(500),
                    // LearnToRightClickModal(),
                    // ...RollPhase(), // we don't do it during the first turn of the tutorial!!!
                    ...RollPhase(),
                ]
            },
            {
                "trigger": "turn:every-odd:start",
                "events": [
                    PlotSteps.PlayStinger("Stinger:EnemyTurn"),
                    PlotSteps.TurnStart("bad"),
                ]
            },
            {
                "condition": (stage) => {
                    return stage.turn.number % 2 == 0
                        && stage.turn.phase == "start"
                        && PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"}) != true
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    HandleSlowDeath(),
                    RollPhase(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
            // {
            //     "condition": (stage) => {
            //         return stage.turn.number % 2 == 1
            //             && stage.turn.phase == "end"
            //             && PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"}) != true
            //     },
            //     "events": [
            //         PlotSteps.PlayStinger("Stinger:EnemyTurn"),
            //         PlotSteps.TurnStart("good"),
            //     ]
            // },






            {
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"})
                },
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportSuccessAnalytics(),
                    HandleSlowDeath({"isEndOfEncounter": true}),
                    // Healing(),

                    // PlotSteps.PlayAudio("Ambience:Forest"),
                    PlotSteps.PlayAudio("Ember:Music:Encounter:2"),
                    // LootModal(),
                    DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": 2, "spotTag": "goodspawn"}),
                    // DO NOT PRUNE HERE??
                    PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
                    Step.deltastage({ // TODO: move into dicebound flow
                        "player": {
                            "rollcount": STARTING_ROLLCOUNT
                        },
                    }),
                    RollPhase(), // TODO: move into dicebound flow
                    Step.flag("hud", "visible"),
                ]
            },
            {
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"})
                },
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportSuccessAnalytics(),
                    HandleSlowDeath({"isEndOfEncounter": true}),
                    // Healing(),

                    // PlotSteps.PlayAudio("Ambience:Forest"),
                    PlotSteps.PlayAudio("Ember:Music:Campfire"),
                    DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": 3, "spotTag": "goodspawn"}),
                    PlotSteps.Wait(2000, {"isUnskippable": true}), // TODO: move into dicebound flow
                    PruneOffscreenUnits(), // TODO: move into dicebound flow
                    "KULLERVO: ENTERS #position:1 #direction:right",
                    "KULLERVO: Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    "CRESCENT: ENTERS #position:4 #direction:left",
                    "CRESCENT: Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    "ASHE: ENTERS #position:2 #direction:right",
                    "ASHE: Nulla velit enim, maximus eget ante nec, malesuada dignissim velit. #expression:happy",
                    "CRESCENT: Phasellus ut risus justo.",
                    // "KULLERVO: Donec velit ante, dictum sed massa ut, egestas dictum eros. In erat arcu, placerat non rutrum sit amet, placerat sit amet metus.",
                    // "CRESCENT: Sed sit amet ornare felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    // PlotSteps.PlayStinger("Stinger:Success"),
                    // PlotSteps.PlayAudio("Dicebound:Music:2"),
                    Looting(),
                    // MerchantModal(),
                    PlotSteps.KillAudio({"label": "ambience"}),
                    OverworldModal(),
                    WhatHappensNext(),
                    Step.flag("hud", "visible"),
                ]
            },
            {
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey >= 3
                        && PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"})
                },
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportSuccessAnalytics(),
                    HandleSlowDeath({"isEndOfEncounter": true}),
                    Healing(),
                    // PlotSteps.PlayStinger("Stinger:Success"),
                    PlotSteps.PlayAudio("Dicebound:Music:2"),
                    Looting(),
                    PlotSteps.KillAudio({"label": "ambience"}),
                    OverworldModal(),
                    WhatHappensNext(),
                    Step.flag("hud", "visible"),
                ]
            },
            {

                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.PlayAudio("Stinger:Failure"),
                    PlotSteps.KillAudio({"label": "ambience"}),
                    PlotSteps.ReportFailureAnalytics(),
                    PlotSteps.ChapterFailure(),
                    PlotSteps.Go("/games/ember/title"),
                ]
            },
        ]
    },
}

// TODO: move this to DiceboundFlow
function Looting() {
    return (stage) => {
        const encounterType = stage?.overworld?.player?.encounter?.type ?? "first-combat"
        if(encounterType == "standard-combat"
        || encounterType == "first-combat") {
            return LootModal()
        }
        if(encounterType == "elite-combat") {
            return [
                LootPassiveModal(),
                LootModal(),
            ]
        }
    }
}

// TODO: move this to DiceboundFlow
function WhatHappensNext() {
    return (stage) => {
        const nextEncounterKey = parseInt(stage.currentEncounterKey) + 1

        if(stage.overworld?.player?.encounter == undefined) return
        // console.log(stage.overworld.player.encounter)
        // if(stage.overworld.player.encounter.type == "merchant") {
        //     // return {"func": () => console.log("1!!")}
        //     return ["BUY SOMETHING WILL YA"]
        // }
        if(stage.overworld.player.encounter.type == "random") {
            const randomEvent = stage.random.element(EmberRandomEvents)
            return [
                Step.flag("hud", "hidden"),
                PlotSteps.PlayAudio("Dicebound:Music:2"),
                PlotSteps.PlayAudio("Ambience:Forest"),
                GenerateEncounter(nextEncounterKey),
                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                PruneOffscreenUnits(), // TODO: move into dicebound flow
                PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
                "CRESCENT: Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                "CRESCENT: Nulla velit enim, maximus eget ante nec, malesuada dignissim velit.",
                "CRESCENT: Sed sit amet ornare felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                "CRESCENT: (Sorry, this is a work-in-progress!! In the final game, you'd encounter something strange and mysterious here~)",
                Step.flag("hud", "visible"),
                // randomEvent,
            ]
        }
        if(stage.overworld.player.encounter.type == "campfire") {
            return [
                Step.flag("hud", "hidden"),
                PlotSteps.PlayAudio("Ember:Music:Campfire"),
                PlotSteps.PlayAudio("Ambience:Campfire"),
                GenerateEncounter(nextEncounterKey),
                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                PruneOffscreenUnits(), // TODO: move into dicebound flow
                PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
                "YOU REST, RECOVERING YOUR HEALTH.",
                PlotSteps.HealPlayerParty({"percent": 1}),
                Step.flag("hud", "visible"),
            ]
        }
        if(stage.overworld.player.encounter.type == "treasure") {
            return [
                Step.flag("hud", "hidden"),
                PlotSteps.PlayAudio("Dicebound:Music:2"),
                PlotSteps.PlayAudio("Ambience:Forest"),
                GenerateEncounter(nextEncounterKey),
                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                PruneOffscreenUnits(), // TODO: move into dicebound flow
                PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
                // "CRESCENT: (Sorry, this is a work-in-progress!! In the final game, you'll pick from one of three treasures!!)",
                LootPassiveModal(),
                Step.flag("hud", "visible"),
            ]
        }
        if(stage.overworld.player.encounter.type == "merchant") {
            return [
                Step.flag("hud", "hidden"),
                PlotSteps.PlayAudio("Dicebound:Music:2"),
                PlotSteps.PlayAudio("Ambience:Forest"),
                GenerateEncounter(nextEncounterKey),
                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                PruneOffscreenUnits(), // TODO: move into dicebound flow
                PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
                MerchantModal(),
                Step.flag("hud", "visible"),
            ]
        }
        if(stage.overworld.player.encounter.type == "exit") {
            return [
                PlotSteps.PlayAudio("Dicebound:Music:2"),
                PlotSteps.PlayAudio("Ambience:Forest"),
                PlotSteps.ReportSuccessAnalytics(),
                PlotSteps.PlayAudio("Stinger:Success"),
                PlotSteps.ChapterSuccess(),
                PlotSteps.TransitionStart({"isUnskippable": true}),
                PlotSteps.Wait(250, {"isUnskippable": true}),
                PlotSteps.WaitingModal({"isUnskippable": true, "duration": 2000}),
                PlotSteps.KillAudio({"label": "ambience"}),
                Step.flag("blackout", true),
                "CRESCENT: ENTERS #position:4 #direction:left",
                "CRESCENT: Hail, traveler!!",
                "CRESCENT: Thank you for playing Embergrim.",
                "CRESCENT: The game is still a work-in-progress, with so much left to do.",
                "CRESCENT: Please leave us a comment here on itchio, we'd really appreciate the feedback!!!",
                {"func": () => Navigation.go("/games/ember/title")}
            ]
        }
        const ENCOUNTER_MUSIC = {
            "standard-combat": "Ember:Music:Encounter:" + (stage.overworld.player.position.x % 2 == 0 ? "3" : "1"),
            "elite-combat": "Ember:Music:Encounter:2",
            "final-combat": "Ember:Music:Boss",
        }
        // stage.overworld.player.encounter.type == "first-combat"
        // stage.overworld.player.encounter.type == "standard-combat"
        // stage.overworld.player.encounter.type == "elite-combat"
        // stage.overworld.player.encounter.type == "final-combat"
        return [
            // PlotSteps.PlayAudio(stage.overworld.player.encounter.type == "final-combat" || stage.overworld.player.encounter.type == "elite-combat" ? "Dicebound:Music:Boss" : "Dicebound:Music:1B"),
            PlotSteps.PlayAudio(ENCOUNTER_MUSIC[stage.overworld.player.encounter.type] ?? ENCOUNTER_MUSIC["standard-combat"]),
            PlotSteps.PlayAudio("Ambience:Forest"),
            GenerateEncounter(nextEncounterKey),
            DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
            PruneOffscreenUnits(), // TODO: move into dicebound flow
            PlotSteps.Wait(1000, {"isUnskippable": true}), // TODO: move into dicebound flow
            Step.deltastage({ // TODO: move into dicebound flow
                "player": {
                    "rollcount": STARTING_ROLLCOUNT
                },
            }),
            RollPhase(),
        ]
    }
}

// TODO: should we delete spots and encounters here too?
function PruneOffscreenUnits() {
    return (stage) => {
        const offscreenUnits = Object.values(stage.units).filter((unit) => {
            return Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position) == false
                && unit.affiliation != "good" // TODO: remove this
        })

        const deltaunits = {}
        offscreenUnits.forEach((unit) => {
            deltaunits[unit.key] = null
        })

        return Step.deltastage({
            "units": deltaunits
        })
    }
}

function Healing() {
    return function(stage) {
        if(window.extraHealing == undefined) return

        const currentEncounter = stage.encounters[stage.currentEncounterKey]
        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == stage.player.affiliation
                && unit.health != 0
                && unit.isDead != true
                && Geometry.isInBounds(currentEncounter, unit.position)
            })

        return [
            {
                "name": "HealUnits",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        let newhealth = unit.health + (window.extraHealing || 0)
                        newhealth = Math.min(unit.maxhealth, newhealth)
                        return {
                            "unit": {
                                "key": unit.key,
                                "isDead": false,
                                "health": newhealth,
                            }
                        }
                    }),
                ]
            },
        ]
    }
}
